import { render } from "./TabDrawer.vue?vue&type=template&id=c4b9e494&scoped=true&ts=true"
import script from "./TabDrawer.vue?vue&type=script&lang=ts"
export * from "./TabDrawer.vue?vue&type=script&lang=ts"

import "./TabDrawer.vue?vue&type=style&index=0&id=c4b9e494&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b9e494"]])

export default __exports__